import { render, staticRenderFns } from "./LinkHandling.vue?vue&type=template&id=655ec857&"
import script from "./LinkHandling.vue?vue&type=script&lang=js&"
export * from "./LinkHandling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports